import React from "react";
import { Images } from "../assets";

// Data Array
const imageData = [
  {
    src: Images.CFF,
    alt: "SBB CFF FFS",
  },
  {
    src: Images.CHEYRES,
    alt: "Commune de Cheyres-Châbles",
  },
  {
    src: Images.CHEVROUX,
    alt: "Administration communale de Chevroux",
  },
  {
    src: Images.LANDERON,
    alt: "Administration Communale du Landeron",
  },
  {
    src: Images.FERRING,
    alt: "Ferring International Center SA",
  },
  {
    src: Images.HERAUS,
    alt: "Heraeus Materials",
  },
  {
    src: Images.MICARNA,
    alt: "Micarna SA",
  },
  {
    src: Images.BADER,
    alt: "Bader Fers Recycling SA",
  },
  {
    src: Images.NEUWERTH,
    alt: "Neuwerth Logistics SA",
  },
  {
    src: Images.LIDL,
    alt: "Lidl Schweiz DL AG",
  },
  {
    src: Images.JNJ,
    alt: "JNJ Automation SA",
  },
  {
    src: Images.CREABETON,
    alt: "Creabeton Matériaux AG",
  },
  {
    src: Images.ABAGEOL,
    alt: "ABA-GEOL SA",
  },
  // {
  //   src: Images.PAUL_GENILLOUD,
  //   alt: "ABA-GEOL SA",
  // },
  {
    src: Images.ISR,
    alt: "ISR Injectobohr SA",
  },
];

const ScrollingLogo = ({ src, alt }) => (
  <div className="flex w-28 h-fit my-auto">
    <img src={src} alt={alt} className="w-full object-cover" />
  </div>
);

const ScrollingLogos = () => {
  return (
    <div className="flex flex-col w-full my-10">

      <div className="flex flex-wrap items-center justify-center gap-10 max-w-full h-fit">
        {imageData.map((item, index) => (
          <ScrollingLogo key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default ScrollingLogos;
